export const meta = (name: string) => {
    const element = document.querySelectorAll(`meta[name=${name}]`)[0];
    return element?.getAttribute("content") ?? "";
};

export const exists = (name: string) => {
    const element = document.querySelectorAll(`meta[name=${name}]`)[0];
    return element !== undefined && element !== null;
};

export const getAuthorizedAxiosConfig = (
    user: any,
    headers?: any,
    config?: any,
    language?: string
): any => {
    const al =
        language === undefined
            ? undefined
            : {
                "Accept-Language": language,
            };
    return {
        ...config,
        withCredentials: true,
        headers: {
            ...headers,
            ...al,
            Authorization: `Bearer ${user.id_token}`,
        },
    };
};

export const withQueryString = (uri: string, key: string, value: string) => {
    const re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    const separator = uri.includes("?") ? "&" : "?";
    if (uri.match(re) != null) {
        return uri.replace(re, "$1" + key + "=" + value + "$2");
    } else {
        return uri + separator + key + "=" + value;
    }
};

const copyToClipboardFallback = (val: string) => {
    const selBox = document.createElement("textarea");
    selBox.style.position = "fixed";
    selBox.style.left = "0";
    selBox.style.top = "0";
    selBox.style.opacity = "0";
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand("copy");
    document.body.removeChild(selBox);
};

export const copyToClipboard = (text: string) => {
    if (navigator.clipboard === undefined || navigator.clipboard == null) {
        copyToClipboardFallback(text);
        return;
    }
    navigator.clipboard.writeText(text).then(
        function () { },
        function (err) {
            console.error("Could not copy text: ", err);
        }
    );
};
